import { FacetsComponent } from "../components/facets.component";

const BaseProductFacets = () => (
    <FacetsComponent component={"PRODUCT_FACETS"} />
);

export { BaseProductFacets };
